import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { interval } from 'rxjs';
import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PwaUpdateService {

  constructor(
    public updates: SwUpdate,
    private toastController: ToastController
  ) {
    const intervalTime = 60 * 60 * 6;
    if (updates.isEnabled) {
      console.log('Registrando atualizador PWA');
      interval(intervalTime).subscribe(() => updates.checkForUpdate()
        .then(() => console.log('checking for updates')));
    }
  }

  public checkForUpdates(): void {

    if (this.updates.isEnabled) {
      console.log('Registrando atualizador PWA');
      
      this.updates.versionUpdates.
      pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
        map(evt => ({
          type: 'UPDATE_AVAILABLE',
          current: evt.currentVersion,
          available: evt.latestVersion,
        }))).subscribe(() => {
          
          this.updates.activateUpdate().then(() => {
            this.showUpdateMessage();
          });

        });
    }   
  }

  async showUpdateMessage(): Promise<void> {
    const toast = await this.toastController.create({
      message: 'Existe uma nova versão deste App disponível',
      duration: 10000,
      buttons: [{
        text: 'Atualizar',
        handler: () => {
          /* tslint:disable */
          window.location.reload();
          /* tslint:enable */
        }
      }]
    });

    toast.present();
  }
}
